import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const TRIM = () => {
  return (
    <CardSection id="TRIM" title="TRIM">
      <Paragraph>
        지정된 문자열의 모든 선행 및 후행 공백을 제거합니다.
        <br />
        <br />
        <b>중요:</b> <b>TRIM</b> 함수는 기본적으로 텍스트에서 일반적인 공백
        문자(ASCII 값 32)만 제거하도록 설계돼 있습니다. 하지만 유니코드 문자
        중에는 160번 코드에 해당하는 줄바꿈되지 않는 공백(non-breaking space)
        코드에 해당하는 줄바꿈되지 않는 공백(non-breaking space) 도 있는데, 이
        문자는 보통 웹 페이지에서 <b>{"&nbsp;"}</b>로 사용됩니다.&nbsp;
        <b>TRIM</b> 함수만으로는 이 공백은 제거되지 않으니 주의가 필요합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>TRIM(STRING)</Paragraph>
        <Ul>
          <Li>
            <b>STRING</b>은 트리밍하려는 값입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>TRIM(`Column`)</Paragraph>
        <Img src="computeTrim" />
      </ListSection>
    </CardSection>
  );
};
